module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.b1dfa20f.svg";